module.exports = __webpack_public_path__ + "static/media/111-afghanistan.38ddcf8a.svg";